module.exports = __webpack_public_path__ + "img/caret-up-square-fill.679c70e8.svg";